/* Dripstock: a subtle sound only after a successful add-to-cart.
   The sound is enabled by a shopper interaction for mobile browser audio policies. */
(() => {
  'use strict';

  let audioContext = null;
  let lastSoundAt = -Infinity;

  function armAudio() {
    try {
      const Context = window.AudioContext || window.webkitAudioContext;
      if (!Context) return;
      if (!audioContext) audioContext = new Context();
      if (audioContext.state === 'suspended') {
        audioContext.resume().catch(() => {});
      }
    } catch (_) {
      // Lack of audio support should never affect cart functionality.
    }
  }

  document.addEventListener('pointerdown', armAudio, { capture: true, passive: true });
  document.addEventListener('click', armAudio, { capture: true, passive: true });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') armAudio();
  }, { capture: true });

  function playAddSuccess() {
    if (window.DripstockSound && !window.DripstockSound.enabled()) return;
    if (!audioContext || audioContext.state !== 'running') return;
    const now = performance.now();
    if (now - lastSoundAt < 250) return;

    try {
      const start = audioContext.currentTime + 0.012;
      for (const tone of [
        { delay: 0, start: 690, end: 620, duration: 0.105, volume: 0.06 },
        { delay: 0.072, start: 940, end: 855, duration: 0.155, volume: 0.045 },
      ]) {
        const begin = start + tone.delay;
        const oscillator = audioContext.createOscillator();
        const gain = audioContext.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(tone.start, begin);
        oscillator.frequency.exponentialRampToValueAtTime(tone.end, begin + tone.duration);
        gain.gain.setValueAtTime(0.0001, begin);
        gain.gain.exponentialRampToValueAtTime(tone.volume, begin + 0.012);
        gain.gain.exponentialRampToValueAtTime(0.0001, begin + tone.duration);
        oscillator.connect(gain);
        gain.connect(audioContext.destination);
        oscillator.start(begin);
        oscillator.stop(begin + tone.duration + 0.01);
        oscillator.onended = () => {
          oscillator.disconnect();
          gain.disconnect();
        };
      }
      lastSoundAt = now;
    } catch (_) {
      // Audio is optional and must never affect buying.
    }
  }

  // Matches the store's cart drawer event contract.
  // The promise resolves after Shopify confirms the cart update.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add' || !event.promise || typeof event.promise.then !== 'function') return;
    event.promise.then((result) => {
      if (!result?.cart || result.detail?.didError || result.userErrors?.length) return;
      playAddSuccess();
    }).catch(() => {});
  });
})();
